<template>
    <el-tag size="mini" v-if="level == 5">国家</el-tag>
    <el-tag type="success" size="mini" v-else-if="level == 6">省级</el-tag>
    <el-tag type="info" size="mini" v-else-if="level == 7">市级</el-tag>
    <el-tag type="warning" size="mini" v-else-if="level == 8">区县级</el-tag>
    <el-tag type="danger" size="mini" v-else-if="level == 9">特区级</el-tag>
</template>
<script>
export default {
    name: "SiteLevelTag",
    props: {
        level: {
            type: [String, Number],
            default: 5
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SiteLevelTag.vue